export const GET_ISSUER_INVITES_SUCCESS = 'GET_ISSUER_INVITES_SUCCESS';
export const SET_ISSUER_INVITES_LOADING = 'SET_ISSUER_INVITES_LOADING';

export const SEND_ISSUER_INVITES_SUCCESS = 'SEND_ISSUER_INVITES_SUCCESS';
export const CANCEL_ISSUER_INVITE_SUCCESS = 'CANCEL_ISSUER_INVITE_SUCCESS';